import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon PersonIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const PersonIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 17 20">
      <ellipse fill="none" cx={8.5} cy={5.26} rx={5.31} ry={5.26} />
      <path
        fill="none"
        d="M6.38,9.47h4.25c3.5-0.02,6.35,2.81,6.37,6.31c0,0,0,0.01,0,0.01V20H0v-4.21C0.02,12.28,2.87,9.45,6.38,9.47 C6.38,9.47,6.38,9.47,6.38,9.47z"
      />
      <path d="M11.56,9.55c1.41-0.98,2.25-2.58,2.25-4.29c0-2.93-2.38-5.31-5.31-5.31c-2.93,0-5.31,2.38-5.31,5.31 c0,1.71,0.84,3.31,2.25,4.29C2.33,10,0.02,12.65,0,15.79v2.63C0.01,19.29,0.72,20,1.59,20h13.82c0.87,0,1.58-0.71,1.59-1.58v-2.63 C16.98,12.65,14.67,10,11.56,9.55z M8.5,1.55c2.04,0.02,3.68,1.68,3.66,3.72s-1.68,3.68-3.72,3.66C6.42,8.91,4.79,7.28,4.78,5.26 C4.79,3.22,6.46,1.57,8.5,1.58c0,0,0,0,0,0V1.55z M15.41,18.39H1.59v-2.6c0.02-2.63,2.16-4.75,4.79-4.74h4.24 c2.63-0.01,4.77,2.11,4.79,4.74V18.39z" />
    </Icon>
  )
}
export default PersonIcon
